var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"block-list"},_vm._l((_vm.blocks),function(block,ix){return _c('block-render',{key:_vm.blockKey(block, ix),attrs:{"block":block,"is-first-block":ix === 0}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }